// export const API_BASE_URL = 'https://your-api-url.com/'

export const API_ENDPOINT = {
  TOKEN_AUTH: '/token/auth'
};
